// extracted by mini-css-extract-plugin
module.exports = {"CheckBox":"CheckBox_CheckBox__6ma00","Checkmark":"CheckBox_Checkmark__3L-E4","Error":"CheckBox_Error__2RWeI","ErrorItem":"CheckBox_ErrorItem__2IcjQ"};